import { render } from "./LoginAuthPage.vue?vue&type=template&id=2e99d894&scoped=true"
import script from "./LoginAuthPage.vue?vue&type=script&lang=js"
export * from "./LoginAuthPage.vue?vue&type=script&lang=js"

import "./LoginAuthPage.vue?vue&type=style&index=0&id=2e99d894&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice-base-vue3/backoffice-base-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e99d894"]])

export default __exports__